import axios from "axios";
import { MatchZ, Scorecard, ScorecardZ } from "../schema/schema";
axios.defaults.baseURL = "https://grassrootsapiproxy.cricket.com.au";

export const getScorecards = async (gradeId: string, orgId: string) => {
	const matchesURL = `/scores/grades/${gradeId}/matches`;
	const matchesResponse = await axios.get(matchesURL);
	const matches = MatchZ.array()
		.parse(matchesResponse.data.Matches)
		.filter(match => match.Teams.find(team => team.OwningOrganisation.Id === orgId));

	const scorecardList = matches.map(async match => {
		const scorecard: Promise<Scorecard> = getScorecard(match.Id);
		return scorecard;
	});

	const resolvedScorecards = await Promise.all(scorecardList);
	return resolvedScorecards;
};

const getScorecard = async (matchId: string) => {
	const scorecardURL = `/scores/matches/${matchId}?responseModifier=includeScorecard`;
	const scorecardResponse = await axios.get(scorecardURL);
	return ScorecardZ.parse(scorecardResponse.data);
};
